export class UpdateRolesDto {
  rolesIds: number[];
}
